import ReportsFilters from './ReportsFilters';
import KpiCards from './KpiCards';
import ReportTable from './ReportTable';
import { formatCurrency, formatNumber, formatPercent } from './formatters';

const PropertyPerformance = ({
  data = [],
  filters,
  onFiltersChange,
  onApply,
  onExport,
  loading,
  exporting,
  properties = [],
  hosts = [],
  showHost = false,
  loadingMeta = false,
}) => {
  const totals = data.reduce(
    (acc, row) => {
      acc.gross += Number(row.grossRevenue || 0);
      acc.earnings += Number(row.hostEarnings || 0);
      acc.bookings += Number(row.totalBookings || 0);
      return acc;
    },
    { gross: 0, earnings: 0, bookings: 0 }
  );

  return (
    <div className="space-y-4">
      <ReportsFilters
        filters={filters}
        onChange={onFiltersChange}
        onApply={onApply}
        onExport={onExport}
        properties={properties}
        hosts={hosts}
        showHost={showHost}
        showProperty
        showGroupBy={false}
        loadingMeta={loadingMeta}
        applying={loading}
        exporting={exporting}
      />

      <KpiCards
        items={[
          { label: 'Gross revenue', value: totals.gross, render: (v) => formatCurrency(v) },
          { label: 'Host earnings', value: totals.earnings, render: (v) => formatCurrency(v) },
          { label: 'Total bookings', value: totals.bookings, render: (v) => formatNumber(v) },
        ]}
      />

      <ReportTable
        loading={loading}
        columns={[
          { key: 'title', label: 'Property' },
          { key: 'totalBookings', label: 'Bookings', render: formatNumber },
          { key: 'confirmedBookings', label: 'Confirmed', render: formatNumber },
          { key: 'cancelledBookings', label: 'Cancelled', render: formatNumber },
          { key: 'bookedNights', label: 'Booked nights', render: formatNumber },
          { key: 'availableNights', label: 'Available nights', render: formatNumber },
          { key: 'occupancyRate', label: 'Occupancy', render: (v) => formatPercent(v) },
          { key: 'grossRevenue', label: 'Gross', render: (v) => formatCurrency(v) },
          { key: 'hostEarnings', label: 'Host earnings', render: (v) => formatCurrency(v) },
          { key: 'adr', label: 'ADR', render: (v) => formatCurrency(v) },
        ]}
        rows={data}
        emptyText="No property performance data."
      />
    </div>
  );
};

export default PropertyPerformance;
